var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex justify-start",attrs:{"outlined":"","tile":""}},[_c('v-select',{staticClass:"pl-3 pr-3",attrs:{"items":_vm.wsStatusItems,"item-text":"DS_NAME","item-value":"DS_ID","label":"Статус конфигурации","no-data-text":"Нет данных"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }